module.exports = __webpack_public_path__ + "img/allianz.856387ed.svg";